import React from 'react'
import { useNavigate } from 'react-router-dom'
import './style.scss'
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded'
import InstagramIcon from '@mui/icons-material/Instagram'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import footerlogo from '../assets/images/ugks_logo.png'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'

const Footer = () => {
  const navigate = useNavigate()

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const navLinks = [
    { label: 'Home', onClick: () => window.location.href = 'https://rlimo.sg/' },
    { label: 'About Us', onClick: () => navigate('/aboutus') },
    { label: 'Services', onClick: () => window.location.href = 'https://rlimo.sg/services/' },
    { label: 'Fleet & Rates', onClick: () => window.location.href = 'https://rlimo.sg/fleet-and-rates/' },
    { label: 'Contact', onClick: () => window.location.href = 'https://rlimo.sg/contact/' },
    { label: 'Booking', onClick: () => window.location.href = 'https://rlimo.sg/booking-form/' },
  ]

  const infoLinks = [
    { label: 'FAQ', onClick: () => navigate('/FAQ') },
    { label: 'Terms & Conditions', onClick: () => navigate('/termsconditions') },
    { label: 'Privacy Policy', onClick: () => window.location.href = 'https://rlimo.sg/privacy-policy/' },
    { label: 'Customer Registration', onClick: () => navigate('/customerregistration') },
    // { label: 'B2B Registration', onClick: () => navigate('/b2bregistration') },
  ]

  return (
    <footer className="site-footer">
      <div className="footer-top-btn" onClick={scrollToTop}>
        <ArrowUpwardIcon />
      </div>

      <div className="footer-main">
        <Container>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={3}>
              <div className="footer-brand">
                <img src={footerlogo} alt="Red Ace Limo" className="footer-logo" />
                <p className="footer-desc">
                  Premium limousine services in Singapore since 2018. Experience luxury travel with our dedicated fleet of Mercedes.
                </p>
                <div className="footer-social">
                  <a href="https://www.instagram.com/redacelimousines/" target="_blank" rel="noreferrer" className="social-link">
                    <InstagramIcon />
                  </a>
                  <a href="https://www.facebook.com/profile.php?id=61560439183440&mibextid=LQQJ4d" target="_blank" rel="noreferrer" className="social-link">
                    <FacebookRoundedIcon />
                  </a>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <h4 className="footer-title">Quick Links</h4>
              <ul className="footer-links">
                {navLinks.map(link => (
                  <li key={link.label} onClick={link.onClick}>{link.label}</li>
                ))}
              </ul>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <h4 className="footer-title">Information</h4>
              <ul className="footer-links">
                {infoLinks.map(link => (
                  <li key={link.label} onClick={link.onClick}>{link.label}</li>
                ))}
              </ul>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <h4 className="footer-title">Get in Touch</h4>
              <div className="footer-contact-info">
                <div className="contact-item">
                  <LocationOnIcon className="contact-icon" />
                  <span>7 Temasek Boulevard #12-07 Suntec Tower One, Singapore 038987</span>
                </div>
                <div className="contact-item">
                  <PhoneIcon className="contact-icon" />
                  <div className="contact-phones">
                    <a href="tel:+6597624240">+65 9762 4240</a>
                    <a href="tel:+6592724689">+65 9272 4689</a>
                  </div>
                </div>
                <div className="contact-item">
                  <EmailIcon className="contact-icon" />
                  <a href="mailto:enquiry@rlimo.sg">enquiry@rlimo.sg</a>
                </div>
              </div>
            </Grid>
          </Grid>

          <div className="footer-divider" />

          <div className="footer-bottom">
            <div className="footer-bottom-left">
              <span className="payment-label">We Accept</span>
              <img src="https://rlimo.sg/wp-content/uploads/2024/06/download.png" alt="Payment methods" className="payment-img" />
            </div>
            <div className="footer-bottom-right">
              <span className="business-id">Business Registered ID: 53395806K</span>
            </div>
          </div>
        </Container>
      </div>

      <div className="footer-copyright">
        <Container>
          <div className="copyright-inner">
            <p className="copyright-text">&copy; {new Date().getFullYear()} Red Ace Limo. All rights reserved.</p>
            <div className="copyright-links">
              <span onClick={() => window.location.href = 'https://rlimo.sg/privacy-policy/'}>Privacy Policy</span>
              <span className="copyright-sep">|</span>
              <span onClick={() => navigate('/termsconditions')}>Terms of Service</span>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  )
}

export default Footer
